// extracted by mini-css-extract-plugin
export default {"container":"_4bK3J","infoContainer":"PAX-S","rowAndSeat":"WJGFF","ticketInfoContainer":"_6+TDP"};